import React, { useEffect, useState } from 'react'

const BasicDomainNameNumberCalculator = () => {

  const [result, setResult] = useState({"chaldean": [0,0,0], "pythagorean": [0,0,0]})

  const [includeNumbers, setIncludeNumbers] = useState(false)
  const [textInput, setTextInput] = useState("")

  const data = {
    meanings: {
        destiny: {
          1: "Independent, pioneering, and a natural leader. You're destined to initiate and innovate.",
          2: "Cooperative, diplomatic, and a peace-seeker. You're meant to harmonize and support.",
          3: "Creative, expressive, and joyful. You're here to inspire through words and art.",
          4: "Disciplined, methodical, and a builder. You're here to create structure and stability.",
          5: "Adventurous, dynamic, and freedom-loving. You're destined for change and experience.",
          6: "Caring, responsible, and nurturing. You're meant to serve and protect others.",
          7: "Spiritual, analytical, and introspective. Your destiny involves inner wisdom and truth.",
          8: "Powerful, ambitious, and materially successful. You're meant to manage and influence.",
          9: "Compassionate, humanitarian, and wise. Your path involves global service and healing."
        },
        urge: {
          1: "Desire for independence, achievement, and recognition.",
          2: "Craves connection, partnership, and emotional harmony.",
          3: "Longs for self-expression, joy, and creativity.",
          4: "Wants security, order, and practical success.",
          5: "Needs freedom, variety, and new experiences.",
          6: "Yearns to help, nurture, and support others.",
          7: "Desires truth, knowledge, and spiritual insight.",
          8: "Seeks power, success, and material control.",
          9: "Feels driven to serve humanity and bring healing."
        },
        personality: {
          1: "Seen as confident, assertive, and a natural leader.",
          2: "Perceived as gentle, sensitive, and cooperative.",
          3: "Charismatic, sociable, and optimistic in appearance.",
          4: "Viewed as reliable, grounded, and hardworking.",
          5: "Energetic, fun-loving, and versatile to others.",
          6: "Appears warm, helpful, and compassionate.",
          7: "Seen as wise, quiet, and mysterious.",
          8: "Comes across as strong, commanding, and ambitious.",
          9: "Perceived as generous, noble, and idealistic."
        }
    }
  }

    function calculateNameNumbers(name, includeNumbers = false) {

        function reduceToSingleDigit(num) {
            while (num > 9) {
                num = num.toString().split('').reduce((a, b) => a + parseInt(b), 0);
            }
            return num;
        }

        const vowels = ['A', 'E', 'I', 'O', 'U'];

        const chaldeanMap = {
            A: 1, B: 2, C: 3, D: 4, E: 5, F: 8, G: 3, H: 5, I: 1,
            J: 1, K: 2, L: 3, M: 4, N: 5, O: 7, P: 8, Q: 1, R: 2,
            S: 3, T: 4, U: 6, V: 6, W: 6, X: 5, Y: 1, Z: 7
        };

        const pythagoreanMap = {
            A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8, I: 9,
            J: 1, K: 2, L: 3, M: 4, N: 5, O: 6, P: 7, Q: 8, R: 9,
            S: 1, T: 2, U: 3, V: 4, W: 5, X: 6, Y: 7, Z: 8
        };

        const cleanName = name.toUpperCase().match(/[A-Z0-9]/g) || [];

        const calculateNumbers = (map) => {
            let total = 0;
            let vowelSum = 0;
            let consonantSum = 0;

            cleanName.forEach(char => {
                if (/[A-Z]/.test(char)) {
                    const value = map[char];
                    total += value;
                    if (vowels.includes(char)) {
                        vowelSum += value;
                    } else {
                        consonantSum += value;
                    }
                } else if (includeNumbers && /\d/.test(char)) {
                    total += parseInt(char); // Add numeric digits only to total
                }
            });

            return [
                reduceToSingleDigit(total),
                reduceToSingleDigit(vowelSum),
                reduceToSingleDigit(consonantSum)
            ];
        };

        return {
            chaldean: calculateNumbers(chaldeanMap),
            pythagorean: calculateNumbers(pythagoreanMap)
        };
    }

    useEffect(() => {
        if (textInput !== "") {
            setResult(calculateNameNumbers(textInput, includeNumbers))
        } else {
            setResult({"chaldean": [0,0,0], "pythagorean": [0,0,0]})
        }
    }, [textInput, includeNumbers])

  return (
    <>

        <section className="mx-auto max-w-[85rem] py-11">

            
            <div className="max-w-xl mx-auto">   
                <label htmlFor="default-search" className="mb-2 text-sm font-medium leading-loose text-gray-900 sr-only">Search</label>
                <div className="relative">
                    <input onInput={(e) => {setTextInput(e.target.value)}} type="search" className="block w-full p-4 ps-10 text-sm text-gray-600 focus:shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] duration-300 border border-gray-200 rounded-lg outline-none" required />
                </div>
                <div className="flex mt-2">
                    <input onInput={(e) => {setIncludeNumbers(e.target.checked)}} type="checkbox" className="shrink-0 mt-0.5 border-gray-200 rounded-sm text-blue-600 focus:ring-blue-500 checked:border-blue-500 disabled:opacity-50 disabled:pointer-events-none" />
                    <label htmlFor="hs-checked-checkbox" className="text-sm text-gray-500 ms-3">Include Numbers</label>
                </div>
            </div>

            <div className="relative overflow-x-auto max-w-4xl mx-auto mt-28 px-5">
                <table className="w-full text-sm text-left text-gray-500">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th scope="col" className="px-6 py-3">
                                Numerology
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Chaldean
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Pythagorean
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="bg-white border-b border-gray-200">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                Destiny Number
                            </th>
                            <td className="px-6 py-4 text-black">
                                <strong>{result.chaldean[0]}</strong>
                            </td>
                            <td className="px-6 py-4">
                                {result.pythagorean[0]}
                            </td>
                        </tr>
                        <tr className="bg-white border-b border-gray-200">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                Soul Urge Number
                            </th>
                            <td className="px-6 py-4 text-black">
                                <strong>{result.chaldean[1]}</strong>
                            </td>
                            <td className="px-6 py-4">
                                {result.pythagorean[1]}
                            </td>
                        </tr>
                        <tr className="bg-white border-b border-gray-200">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                Personality Number
                            </th>
                            <td className="px-6 py-4 text-black">
                                <strong>{result.chaldean[2]}</strong>
                            </td>
                            <td className="px-6 py-4">
                                {result.pythagorean[2]}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="max-w-4xl mx-auto mt-11 px-5 space-y-2">
                {result.chaldean[0] !== 0 && (<p><strong>Destiny Number {result.chaldean[0]}</strong>: {data.meanings.destiny[result.chaldean[0]]}</p>)}
                {result.chaldean[1] !== 0 && (<p><strong>Urge Number {result.chaldean[1]}</strong>: {data.meanings.urge[result.chaldean[1]]}</p>)}
                {result.chaldean[2] !== 0 && (<p><strong>Personality Number {result.chaldean[2]}</strong>: {data.meanings.personality[result.chaldean[2]]}</p>)}
            </div>

            <div className="max-w-4xl mx-auto mt-36 px-5 space-y-5">
                <h2 className='text-center w-full text-xl py-11'>Chaldean Numerology Meanings</h2>

                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                    <div id={`chaldean-${num}`} key={num} className="chaldean-meaning">
                    <h3 className='text-lg py-2'>Number {num}</h3>

                    <p className='pl-5 mt-2'><strong>Destiny Number:</strong> {
                        {
                        1: "Independent, pioneering, and a natural leader. You're destined to initiate and innovate.",
                        2: "Cooperative, diplomatic, and a peace-seeker. You're meant to harmonize and support.",
                        3: "Creative, expressive, and joyful. You're here to inspire through words and art.",
                        4: "Disciplined, methodical, and a builder. You're here to create structure and stability.",
                        5: "Adventurous, dynamic, and freedom-loving. You're destined for change and experience.",
                        6: "Caring, responsible, and nurturing. You're meant to serve and protect others.",
                        7: "Spiritual, analytical, and introspective. Your destiny involves inner wisdom and truth.",
                        8: "Powerful, ambitious, and materially successful. You're meant to manage and influence.",
                        9: "Compassionate, humanitarian, and wise. Your path involves global service and healing."
                        }[num]
                    }</p>

                    <p className='pl-5 mt-2'><strong>Soul Urge Number:</strong> {
                        {
                        1: "Desire for independence, achievement, and recognition.",
                        2: "Craves connection, partnership, and emotional harmony.",
                        3: "Longs for self-expression, joy, and creativity.",
                        4: "Wants security, order, and practical success.",
                        5: "Needs freedom, variety, and new experiences.",
                        6: "Yearns to help, nurture, and support others.",
                        7: "Desires truth, knowledge, and spiritual insight.",
                        8: "Seeks power, success, and material control.",
                        9: "Feels driven to serve humanity and bring healing."
                        }[num]
                    }</p>

                    <p className='pl-5 mt-2'><strong>Personality Number:</strong> {
                        {
                        1: "Seen as confident, assertive, and a natural leader.",
                        2: "Perceived as gentle, sensitive, and cooperative.",
                        3: "Charismatic, sociable, and optimistic in appearance.",
                        4: "Viewed as reliable, grounded, and hardworking.",
                        5: "Energetic, fun-loving, and versatile to others.",
                        6: "Appears warm, helpful, and compassionate.",
                        7: "Seen as wise, quiet, and mysterious.",
                        8: "Comes across as strong, commanding, and ambitious.",
                        9: "Perceived as generous, noble, and idealistic."
                        }[num]
                    }</p>
                    </div>
                ))}

            </div>

        </section>

    </>
  )
}

export default BasicDomainNameNumberCalculator